const initNewsSlider = () => {
  const slider = document.querySelector('[data-slider="news"]');

  if (!slider) {
    return;
  }

  const swiper = new Swiper(slider, {
    slidesPerView: 'auto',
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        spaceBetween: 20,
      },
      660: {
        spaceBetween: 20,
      },
      960: {
        spaceBetween: 20,
      },
      1420: {
        spaceBetween: 30,
      },
    },
  });
};

export { initNewsSlider };
